import React, { StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { COVER } from '../utils/constants';
import './_styles.scss';

export interface ICoverProps {
    image?: string;
    placeholder?: string;
    className?: string;
}

export const Cover: StatelessComponent<ICoverProps> = ({ image, placeholder, className }) => {
    const src = image ?? placeholder ?? '';
    return (
        <div className={cls(COVER, className)}>
            <img alt="Cover" src={src} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Cover/index.tsx